import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
interface StepHeaderProps {
  backTo: string;
  stepText: string;
}
export function StepHeader({
  backTo,
  stepText
}: StepHeaderProps) {
  return <div className="flex items-center justify-between mb-6" data-id="element-239">
      <Link to={backTo} className="flex items-center text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-240">
        <ArrowLeft size={16} className="mr-2" data-id="element-241" />
        Back
      </Link>
      <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-242">
        {stepText}
      </span>
      <div className="w-16" data-id="element-243" /> {/* Spacer for centering */}
    </div>;
}